import { forwardRef, useLayoutEffect, useRef, useState } from "react";
import { Check } from "lucide-react";

export const HitRing = ({ tone = "dark", size = 20 }) => (
  <svg viewBox="0 0 320 320" width={size} height={size} className="hl-btn-ring" aria-hidden>
    <circle cx="160" cy="160" r="130" fill="none" stroke={tone === "dark" ? "rgba(8,8,8,.25)" : "rgba(255,255,255,.2)"} strokeWidth="40" />
    <circle cx="160" cy="160" r="130" fill="none" stroke={tone === "dark" ? "#080808" : "#fff"} strokeWidth="40" strokeDasharray="200 620" strokeLinecap="round" />
  </svg>
);

// Nivel C2 · botón con carga. Sin `className` usa el pill coral de la maqueta.
// `as` permite envolver otro componente (ej. Button de shadcn). `tone` = color del anillo.
export const HitButton = forwardRef(function HitButton(
  { as: Comp = "button", loading = false, done = false, loadingText, doneText, tone, className, style, disabled, children, ...rest },
  ref,
) {
  const inner = useRef(null);
  const [minW, setMinW] = useState();
  useLayoutEffect(() => {
    if (!loading && !done && inner.current) setMinW(inner.current.offsetWidth);
  }, [loading, done, children]);
  const setRefs = (n) => { inner.current = n; if (typeof ref === "function") ref(n); else if (ref) ref.current = n; };
  const ringTone = tone || (className ? "light" : "dark");
  const busy = loading || done;
  return (
    <Comp
      ref={setRefs}
      className={className || "hl-btn"}
      style={{ ...style, ...(busy && minW ? { minWidth: minW } : null) }}
      disabled={disabled || busy}
      aria-busy={loading ? "true" : undefined}
      aria-disabled={disabled || busy ? "true" : undefined}
      data-hit-done={done ? "" : undefined}
      {...rest}
    >
      {loading ? <><HitRing tone={ringTone} />{loadingText || children}</>
        : done ? <><Check size={18} strokeWidth={3} aria-hidden />{doneText || children}</>
        : children}
    </Comp>
  );
});
